export const copyTextToClipboard = (text) => navigator.clipboard.writeText(text);
